"use client";
import Image from "next/image";
import Tag from "../Tag/Tag";
import CustomSlider from "../Slider/Slider";
import CustomNavLink from "../CustomLink/CustomNavLink";
import { useDictionary } from "../DictProvider/DictProvider";
import useImageUrlModifier from "@/lib/useImageUrlModifier";
export default function BestBrand({ brandImage }: { brandImage: any }) {
  const translate = useDictionary();
  const modifyImageUrl = useImageUrlModifier();

  var settings = {
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    nextArrow: false,
    prevArrow: false,
    autoplay: true,
    dots: false,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3
        },
      },
    ],
  };

  return (
    <div id="bestBrand" className="">
      <Tag name={translate?.Home?.bestBrand} />
      <div className="mx-5 md:mx-10">
        <CustomSlider customSettings={settings}>
          {brandImage?.data?.map((item: any, index: number) => (
            <CustomNavLink
              key={index}
              href={`brands/${item?.language?.brandSlug}`}
            >
              <Image
                className="h-[123px] lg:w-[200px] xl:w-[220px]"
                src={modifyImageUrl(item?.brandImg, 220, 123) || ""}
                alt={`brand ${index}`}
                width={220}
                height={123}
                quality={80}
                priority={true}
                sizes="100%, (min-width: 1024px) 200px, (min-width: 1280px) 220px" // Using 100%
              />
            </CustomNavLink>
          ))}
        </CustomSlider>
      </div>
      <div className="flex justify-center">
        <CustomNavLink href="brands">
          <button className="mt-12 rounded-lg px-3 py-1.5 border border-primary text-primary font-base font-semibold">
            {translate?.Home?.viewmore}
          </button>
        </CustomNavLink>
      </div>
    </div>
  );
}
